<div class="edit-zona-grupo">
  <h2>AÑADE O ELIMINA TUS ZONAS</h2>

  <div class="section-zg">
    <div class="displayFlexJustify" *ngFor="let zona of zonas">
      <p class="tipo-zg">{{zona.nombre}}</p>
    <span><img
      src="../../../../../../assets/trash.png"
      (click)="handleClick(zona.id)"
      />
    </span> 
    </div>
  </div>
  <div class="section-zg">
    <h3>Nueva zona</h3>
    <div class="displayFlexJustifyAlign" >
      <form [formGroup]="datosZona" >
        <div class="input-zg">
        <mat-form-field appearance="outline" >
          <mat-label>Denominación de la Zona</mat-label>
          <input
          matInput
          formControlName="nombre"
          required
          class="input-tabla" type="text" id="zona" name="zona" />
        </mat-form-field>
      </div>
      <div class="input-zg">
      <p class="tipo-zg">Seleccione las Instalaciones que desea asignar a esta Zona:</p>
    <mat-form-field appearance="outline">
      <mat-label>Instalaciones</mat-label>
      <mat-select formControlName="instalaciones" multiple>
        
        <mat-checkbox (change)="selectAllInstalaciones($event.checked)" ><strong>Seleccionar Todas</strong></mat-checkbox>
        <mat-option *ngFor="let instalacion of instalaciones" [value]="instalacion.id" #matOption (click)="selectInstalacion(matOption)">{{instalacion.nombre}}</mat-option>


      </mat-select>
    </mat-form-field>
  </div>
  </form>
    </div>
  </div>

  <button class="bbutton__primary btn-guardar-zg"
  [disabled]="datosZona.invalid"
  (click)="addZona()"
  >Guardar</button>
</div>
